import { useCallback } from "react";
import { usePrintContext } from "./PrintProvider.tsx";
import { runPrint } from "./runPrint.ts";

export interface UsePrintResult {
    print: () => Promise<void>;
    isPreparing: boolean;
}

export function usePrint(): UsePrintResult {
    const { isPreparing, coordinator, beginPreparation, endPreparation } = usePrintContext();

    const print = useCallback(() => runPrint({ isPreparing, coordinator, beginPreparation, endPreparation }), [isPreparing, coordinator, beginPreparation, endPreparation]);

    return { print, isPreparing };
}
